import { useState } from 'react';

const useActionMenu = () => {
  // variable to handle the position of the open menu
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  // variable to handle the position of the open menu
  const [isMenuOpen, setOpenMenu] = useState<boolean>(false);

  //to capture click of icon button
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
  };
  // to capture close event of menu
  const handleClose = () => {
    setAnchorEl(null);
    setOpenMenu(false);
  };

  return {
    anchorEl,
    setAnchorEl,
    isMenuOpen,
    setOpenMenu,
    handleClick,
    handleClose,
  };
};

export default useActionMenu;
